import dynamic from 'next/dynamic';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { neutral } from '@style/variables';

interface Props {
  darkMode?: boolean;
  width?: string;
  facebook?: string;
  instagram?: string;
  twitter?: string;
  pinterest?: string;
  youtubeUser?: string;
  youtube?: string;
  website?: string;
}

const componentTypes = {
  facebook: dynamic(() => import('@repo/ui/src/components/Icons/FacebookIcon')),
  twitter: dynamic(() => import('@repo/ui/src/components/Icons/TwitterIcon')),
  instagram: dynamic(() => import('@repo/ui/src/components/Icons/InstagramIcon')),
  youtube: dynamic(() => import('@repo/ui/src/components/Icons/YoutubeIcon')),
  youtubeUser: dynamic(() => import('@repo/ui/src/components/Icons/YoutubeIcon')),
  pinterest: dynamic(() => import('@repo/ui/src/components/Icons/PinterestIcon')),
};

type SocialOption = keyof typeof componentTypes;
type Func = (link: string) => string;
const socialLinks: Record<SocialOption, Func> = {
  facebook: (link) => `https://www.facebook.com/${link}`,
  instagram: (link) => `https://www.instagram.com/${link}/`,
  twitter: (link) => `https://twitter.com/${link}`,
  pinterest: (link) => `https://www.pinterest.com/${link}/`,
  youtubeUser: (link) => `https://www.youtube.com/user/${link}`,
  youtube: (link) => `https://www.youtube.com/${link}`,
};

const Icon = (props: {
  width: string;
  frontFillColor: string;
  backFillColor: string;
  network: string;
}) => <DynamicComponent _componentTypes={componentTypes} _field="network" {...props} />;

const SocialLinks = ({ darkMode = false, width = '40px', ...networks }: Props) => {
  const backgroundColor = neutral[darkMode ? 600 : 800];

  return (
    <ul className="tw-flex-row tw-p-0 tw-grid tw-grid-flow-col tw-gap-2 tw-w-fit tw-list-none">
      {Object.entries(networks).map(([key, value], index) => {
        const link = value && socialLinks[key as SocialOption]?.(value);

        if (!link) return null;

        return (
          <li key={index}>
            <a href={link} rel="noreferrer" target="_blank" aria-label={key}>
              <Icon
                backFillColor={backgroundColor}
                frontFillColor="white"
                width={width}
                network={key}
              />
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialLinks;
